import { IsValidEmail } from "common/EmailUtils";
import Input from "components/Common/Input";
import Copyright from "components/Copyright";
import PageMeta from "components/PageMeta";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Alert, Card, Col, Container, Row } from "reactstrap";
import { bindActionCreators } from "redux";
import { loginUserAccount } from "../../store/actions/Auth";
import { AuthenticationState } from "../../store/reducers/Authentication";
import { RootState } from "../../store/store";
import AuthLogo from "./AuthLogo";
import { useOfficeTranslation } from "i18n/OfficeTranslation";
import LanguageDropdown from "components/CommonForBoth/TopbarDropdown/LanguageDropdown";

interface Props {
    authentication: AuthenticationState;
}

interface Actions {
    loginUserAccount: typeof loginUserAccount;
}

const Login: React.FC<Props & Actions> = ( {
                                               authentication,
                                               loginUserAccount,
                                           } ) => {
    const [ error, setError ] = useState<string | null>( null )

    const [ email, setEmail ] = useState( "" );
    const [ password, setPassword ] = useState( "" );
    const [ totp, setTotp ] = useState( "" );
    const { t } = useOfficeTranslation();

    const navigate = useNavigate();

    /* eslint-disable react-hooks/exhaustive-deps */
    useEffect( () => {
        if ( authentication ) {
            navigate( "/" );
        }
    }, [ authentication ] );

    const handleValidSubmit = () => {
            loginUserAccount( email, password, totp )
                .then( () => {
                    navigate( "/" );
                } )
                .catch( () => {
                    setError( t("common.loginHasFailedCheckYourCredentials") )
                } );

    };

    const invalidForm = email === "" || !IsValidEmail(email) || password.length < 3 || totp.length !== 6;

    return ( <>
        <PageMeta title={ t("authentication.login.login") }/>
        <div className="account-pages my-0 pt-sm-5">
            <Container>
                <Row className="justify-content-center text-center">
                    <Col md={ 10 }>
                        <div className="d-flex justify-content-end mb-2">
                            <LanguageDropdown />
                        </div>
                        <AuthLogo/>
                        <Card className="overflow-hidden">
                            <Row className="g-0">
                                <Col lg={ 6 }>
                                    <div className="p-lg-5 p-4">
                                        <div>
                                            <h5>{t("authentication.login.signIn")}</h5>
                                            <p className="text-muted">
                                                {t("authentication.login.donTTryToHackThisYouWillBeEatenByOurInterns")}
                                            </p>
                                        </div>
                                        <div className="mt-4 pt-3">
                                            { error && <Alert color="danger">{ error }</Alert> }
                                            <Input
                                                name={ "email" }
                                                type={ "email" }
                                                placeholder={ t("authentication.login.emailAddress") }
                                                onChange={ setEmail }
                                            />
                                            <br />
                                            <Input
                                                name={ "password" }
                                                type={ "password" }
                                                placeholder={ t("common.password") }
                                                onChange={ setPassword }
                                                onKeyDown={ e => {
                                                    if ( e.key === "Enter" && !invalidForm ) {
                                                        handleValidSubmit()
                                                    }
                                                } }
                                            />
                                            <br />
                                            <Input
                                                name={ "totp" }
                                                type={ "text" }
                                                placeholder={t("common.totp")}
                                                onChange={ setTotp }
                                                onKeyDown={ e => {
                                                    if ( e.key === "Enter" && !invalidForm ) {
                                                        handleValidSubmit()
                                                    }
                                                } }
                                            />
                                            <br />

                                            <div className="mt-3">
                                                <button
                                                    disabled={invalidForm}
                                                    className="btn btn-primary w-100 waves-effect waves-light"
                                                    onClick={ () => {
                                                        handleValidSubmit()
                                                    } }
                                                >
                                                    {t("authentication.login.logIn")}
                                                </button>
                                            </div>

                                        </div>
                                    </div>
                                </Col>
                                <Col lg={ 6 }>
                                    <div className="p-lg-5 p-4 bg-auth h-100 d-none d-lg-block">
                                        <div className="bg-overlay"></div>
                                    </div>
                                </Col>
                            </Row>
                        </Card>
                        <Copyright/>
                    </Col>
                </Row>
            </Container>
        </div>
    </> );
};

const mapStateToProps = ( state: RootState ) => {
    return {
        authentication: state.Authentication,
    };
};

const mapDispatchToProps = ( dispatch: any ) => {
    return bindActionCreators( { loginUserAccount }, dispatch );
};

export default connect( mapStateToProps, mapDispatchToProps )( Login );
